<template>
  <div id="intro-overlay" class="overlay">
    <step1 v-if="currentStep === 1 && directStep === null" @changeStep="changeStep"></step1>
    <step2 v-if="currentStep === 2 && directStep === null" @changeStep="changeStep"></step2>
    <step3 v-if="currentStep === 3 && directStep === null" @changeStep="changeStep"></step3>
    <step4 v-if="(currentStep === 4 && directStep === null) || directStep === 'step4'"
           @changeStep="changeStep" @goToStep="goToStep"></step4>
    <step4A v-if="directStep === 'step4A'" @changeStep="changeStep" @goToStep="goToStep"></step4A>
    <step5 v-if="(currentStep === 5 && directStep === null)" @changeStep="changeStep"></step5>
    <step6 v-if="(currentStep === 6 && directStep === null)" @changeStep="changeStep"></step6>
    <step7 v-if="(currentStep === 7 && directStep === null)" @changeStep="changeStep"></step7>
    <step8 v-if="(currentStep === 8 && directStep === null)" @finished="finished"></step8>
  </div>
</template>

<script>
import step1 from '@/apps/vendorconsignment/tutorials/step1'
import step2 from '@/apps/vendorconsignment/tutorials/step2'
import step3 from '@/apps/vendorconsignment/tutorials/step3'
import step4 from '@/apps/vendorconsignment/tutorials/step4'
import step4A from '@/apps/vendorconsignment/tutorials/step4A'
import step5 from '@/apps/vendorconsignment/tutorials/step5'
import step6 from '@/apps/vendorconsignment/tutorials/step6'
import step7 from '@/apps/vendorconsignment/tutorials/step7'
import step8 from '@/apps/vendorconsignment/tutorials/step8'

export default {
  components: {
    step1,
    step2,
    step3,
    step4,
    step4A,
    step5,
    step6,
    step7,
    step8
  },
  data: function () {
    return {
      currentStep: 1,
      directStep: null,
      directStepValue: null
    }
  },
  methods: {
    changeStep (next) {
      this.directStep = null

      let i = 1

      if (!next) i = -1

      this.currentStep = this.currentStep + i
    },
    goToStep (step) {
      this.directStep = step
    },
    finished () {
      this.$emit('finished')
    }
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/base.vue